import { PersonEntity } from '../types/PersonEntity';

export function definePersons(): PersonEntity[] {
  return [
    new PersonEntity({
      id: 'dataEngineer',
      name: 'Data Engineer',
      cost: 500,
      consumes: { money: 2 },
      description: 'Builds and maintains data pipelines',
      progressionRequirements: {
        upgrades: ['hr']
      }
    }),

    new PersonEntity({
      id: 'mlEngineer',
      name: 'Machine Learning Engineer',
      cost: 1000,
      consumes: { money: 3 },
      description: 'Builds and maintains ML pipelines and performs feature engineering',
      progressionRequirements: {
        upgrades: ['hr', 'ml']
      }
    }),

    new PersonEntity({
      id: 'aiResearcher',
      name: 'AI Researcher',
      cost: 2500,
      consumes: { money: 10, cleanData: 2, model: 0.05 },
      produces: { researchProgress: 0.5 },
      description: 'Conducts AI research and provides supervision for training pipelines. Produces research points to unlock AI capabilities. Each researcher provides 50 research points storage.',
      progressionRequirements: {
        upgrades: ['hr', 'ml', 'advancedAI']
      }
    }),

    new PersonEntity({
      id: 'reasoningSpecialist',
      name: 'Reasoning Specialist',
      cost: 5000,
      description: 'Fine-tunes models for complex reasoning and inference',
      produces: { reasoningEngine: 0.01 },
      consumes: {
        money: 15,
        cleanData: 2,
        model: 0.1,
        researchProgress: 0.5
      },
      progressionRequirements: {
        upgrades: ['hr', 'ml', 'advancedAI', 'reasoningSystems']
      }
    }),

    new PersonEntity({
      id: 'agiSafetyResearcher',
      name: 'AGI Safety Researcher',
      cost: 10000,
      consumes: { money: 20, researchProgress: 5, reasoningEngine: 0.05 },
      produces: { agiScore: 0.05 },
      description: 'Expert in AI alignment and safety. Required for AGI development. Directly contributes to AGI progress.',
      progressionRequirements: {
        upgrades: ['agiSafety']
      }
    }),
  ];
} 